import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/signup/HomePage';
import Registration from './components/signup/Registration';
import CancelRegistration from './components/signup/CancelRegistration';
import ChildrenStep from './components/signup/ChildrenStep';
import RegistrationFinalize from './components/signup/RegistrationFinalize';
import RegistrationComplete from './components/signup/RegistrationComplete';
import SessionExpired from './components/dashboard/SessionExpired';
import ConfirmRegistration from './components/signup/ConfirmRegistation';
import Layout from './Layout';
import { RegistrationContextProvider } from './components/signup/context/RegistrationContextProvider';
import RegistrationVerification from './components/signup/RegistrationVerification';
import RegistrationAgreement from './components/signup/RegistrationAgreement';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

function App() {
  return (
    <RegistrationContextProvider>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
      <BrowserRouter basename="/kidlab-reg">
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/registration" element={<Registration />} />
            <Route
              path="/cancel-registration"
              element={<CancelRegistration />}
            />
            <Route path="/children-step" element={<ChildrenStep />} />
            <Route
              path="/registration-agreement"
              element={<RegistrationAgreement />}
            />
            <Route
              path="/verify-registration"
              element={<RegistrationVerification />}
            />
            <Route
              path="/registration-complete"
              element={<RegistrationComplete />}
            />
            <Route path="/session-expired" element={<SessionExpired />} />
            <Route
              path="/confirm-registration"
              element={<ConfirmRegistration />}
            />
            <Route
              path="/registration-confirmation"
              element={<RegistrationFinalize />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
      </GoogleReCaptchaProvider>
    </RegistrationContextProvider>
  );
}

export default App;
